import { Select, Table, Row, Col, Empty } from 'antd';
import { map } from 'jquery';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import {
  getTeacherExamsByFilterAvg,
  getFilteredMoreExams,
  getTopicsById,
  getTeachers,
  getGroupsWithTeacher,
  getTeachersSubjectsById,
  getTeacherExamsByFilterAvgById,
  getFilteredMoreExamsById,
} from '../../../actions';
import { Context } from '../../../defaults';

function DirectorReport() {
  const { dictionary, language, setLoading } = useContext(Context);
  const [subjectsList, setSubjectsList] = useState();
  const [teachers, setTeachers] = useState();
  const [groupsList, setGroupList] = useState();
  const [examsList, setExams] = useState();
  const [selectedMoreExam, setSelectedMoreExam] = useState('');
  const [topics, setTopics] = useState([]);
  const [filters, setFilters] = useState({
    teacherId: null,
    groupId: null,
    subjectId: null,
    showTable: false,
  });

  useEffect(() => {
    getTeachers().then(({ data }) => setTeachers(data));
  }, []);

  const onSelectTeacher = (id) => {
    setGroupList(null);
    setExams(null);
    setSelectedMoreExam(null);
    setFilters({ ...filters, teacherId: null });
    if (id) {
      setFilters({ ...filters, teacherId: id });
      getTeachersSubjectsById(id).then(({ data }) => setSubjectsList(data));
      getGroupsWithTeacher(id).then(({ data }) => setGroupList(data));
    }
  };

  function getFilteredExamsList(groupId) {
    setExams(null);
    setSelectedMoreExam(null);
    setLoading(true);
    if (groupId) {
      getTeacherExamsByFilterAvgById({ ...filters, groupId }).then(({ data }) => {
        let qA = [];
        let qAId = [];
        let qB = [];
        let qBId = [];
        let qC = [];
        let qCId = [];
        let ansA = [];
        let ansB = [];
        let ansC = [];
        const examsPoints = [];
        const examsAvgPoints = [];
        let sumA = 0,
          sumB = 0,
          sumC = 0;

        let sumAnsA = 0,
          sumAnsB = 0,
          sumAnsC = 0;

        data.forEach((el) => {
          el.studentExamsList.forEach((el1) => {
            el1.questions.forEach((el2) => {
              if (el2.questionLevel === 'A') {
                qA.push(el2.point);
                qAId.push(el2.id);
              }
              if (el2.questionLevel === 'B') {
                qB.push(el2.point);
                qBId.push(el2.id);
              }
              if (el2.questionLevel === 'C') {
                qC.push(el2.point);
                qCId.push(el2.id);
              }
            });

            el1.studentAnswers.forEach((el3) => {
              if (qAId.includes(el3.questionId)) {
                ansA.push(el3.point);
              }
              if (qBId.includes(el3.questionId)) {
                ansB.push(el3.point);
              }
              if (qCId.includes(el3.questionId)) {
                ansC.push(el3.point);
              }
            });
          });
          // расчет общих баллов
          for (let i = 0; i < qA.length; i++) {
            sumA += parseFloat(qA[i]);
          }
          for (let i = 0; i < qB.length; i++) {
            sumB += parseFloat(qB[i]);
          }
          for (let i = 0; i < qC.length; i++) {
            sumC += parseFloat(qC[i]);
          }
          // расчет средних баллов
          for (let i = 0; i < ansA.length; i++) {
            sumAnsA += parseFloat(ansA[i]);
          }
          for (let i = 0; i < ansB.length; i++) {
            sumAnsB += parseFloat(ansB[i]);
          }
          for (let i = 0; i < ansC.length; i++) {
            sumAnsC += parseFloat(ansC[i]);
          }

          examsPoints.push({
            A: sumA,
            B: sumB,
            C: sumC,
          });

          examsAvgPoints.push({
            A: sumAnsA / el.studentExamsList.length,
            B: sumAnsB / el.studentExamsList.length,
            C: sumAnsC / el.studentExamsList.length,
            avgSum: (sumAnsA + sumAnsB + sumAnsC) / el.studentExamsList.length,
          });

          sumA = 0;
          sumB = 0;
          sumC = 0;
          qA = [];
          qB = [];
          qC = [];

          sumAnsA = 0;
          sumAnsB = 0;
          sumAnsC = 0;
          ansA = [];
          ansB = [];
          ansC = [];
        });
        setExams(data);
        data.map((item, index) => {
          item.points = examsPoints[index];
          item.avgPoints = examsAvgPoints[index];
        });

        setFilters({ ...filters, showTable: true });
        setLoading(false);
      });
    }
  }

  const onSelectMoreExam = (id) => {
    setLoading(true);
    setSelectedMoreExam(null);
    if (id) {
      getFilteredMoreExamsById({ ...filters, id }).then((res) => {
        getTopicsById(res.data.topicsId).then((res) => setTopics(res.data));
        const tempExam = res.data.studentExamsList;
        tempExam.forEach((el) => {
          el.exam = res.data;
        });
        setSelectedMoreExam(tempExam);
        setLoading(false);
      });
    }
  };

  const columns = [
    {
      title: dictionary?.ExamName[language],
      dataIndex: 'name',
      key: 'name',
      render: (text, e2) => (
        <a onClick={() => onSelectMoreExam(e2.id)} key={text}>
          {text}
        </a>
      ),
    },
    {
      title: `${dictionary?.ExamStartDate[language]}`,
      dataIndex: 'examDate',
      key: 'examDate',
      render: (examDate) => moment(examDate).format('L'),
    },
    {
      //title: dictionary?.VariantNumber[language],
      title: 'Средний балл А',
      dataIndex: 'variantNumber',
      key: 'variantNumber',
      render: (e, e1, e2) => {
        return `${e1.avgPoints.A} / ${e1.points.A}`;
      },
    },
    {
      // title: dictionary?.Score[language],
      title: 'Средний балл B',
      key: 'score',
      dataIndex: 'score',
      render: (e, e1, e2) => {
        return `${e1.avgPoints.B} / ${e1.points.B}`;
      },
    },
    {
      // title: dictionary?.MaxPoint[language],
      title: 'Средний балл C',
      key: 'maxPoint',
      dataIndex: 'maxPoint',
      render: (e, e1, e2) => {
        return `${e1.avgPoints.C} / ${e1.points.C}`;
      },
    },
    {
      //title: dictionary?.VariantNumber[language],
      title: 'Общий средний балл',
      dataIndex: 'variantNumber',
      key: 'variantNumber',
      render: (e, e1, e2) => {
        return `${e1.avgPoints.avgSum} / ${e1.studentExamsList[0].maxTotalPoint}`;
      },
    },
  ];

  const columns2 = [
    {
      title: `${dictionary?.Students[language]}`,
      dataIndex: 'id',
      key: 'id',
      render: (e, e1, e2) => {
        return `${e1.exam.studentsList[e2].lastName} ${e1.exam.studentsList[e2].firstName} ${e1.exam.studentsList[e2]?.middleName}`;
      },
    },
    {
      title: `${dictionary?.Group[language]}`,
      dataIndex: 'groupId',
      key: 'groupId',
      render: (e, e1, e2) => {
        return (
          <span key={e2}>
            {groupsList && groupsList.find((el) => el.id === e1.exam.groupId)?.name}
          </span>
        );
      },
    },
    {
      title: `${dictionary?.Topic[language]}`,
      dataIndex: 'topicsId',
      key: 'topicsId',
      render: (e, e1, e2) => (
        <>
          {e1.exam.topicsId.map((item) => {
            return <span key={item}>{topics && topics.find((el) => el.id === item)?.name},</span>;
          })}
        </>
      ),
    },
    {
      title: `${dictionary?.VariantNumber[language]}`,
      dataIndex: 'groupId + 1',
      key: 'groupId + 1',
      render: (e, e1, e2) => {
        return e1.variantNumber;
      },
    },
  ];

  if (selectedMoreExam && selectedMoreExam[0].questionIds.length > 0) {
    for (let i = 0; i < selectedMoreExam[0].questionIds.length; i++) {
      columns2.push({
        title: `${dictionary?.Question[language]} ${i + 1}`,
        dataIndex: `questionId`,
        key: i,
        render: (e, e1, e2) => {
          return `${e1.studentAnswers[i]?.point} / ${e1.exam.questionsPoints[i]?.point}`;
        },
      });
    }
    columns2.push({
      title: `${dictionary?.TotalPoint[language]}`,
      dataIndex: 'totalPoint',
      key: 'totalPoint',
      render: (e, e1, e2) => {
        return `${e1.totalPoint} / ${e1.maxTotalPoint}`;
      },
    });

    // columns2.push({
    //   title: `${dictionary?.Comment[language]}`,
    //   dataIndex: 'comment',
    //   key: 'comment',
    //   render: (e, e1, e2) => {
    //     debugger
    //   },
    // });
  }

  return (
    <React.Fragment>
      <Row style={{ marginTop: '30px' }} gutter={24}>
        <Col span={8}>
          <Select
            placeholder={dictionary?.Teacher[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            onChange={(e) => onSelectTeacher(e)}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}>
            {!!teachers &&
              teachers.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.lastName} {el.firstName} {el.middleName}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder={dictionary?.Subjects[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            disabled={!filters.teacherId}
            onChange={(e) => {
              !!e
                ? setFilters({ ...filters, subjectId: e })
                : setFilters({ ...filters, subjectId: null });
              !e && setSelectedMoreExam(null);
              !e && setExams(null);
            }}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}>
            {subjectsList &&
              subjectsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder={dictionary?.Group[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            disabled={!filters.subjectId || !filters.teacherId}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}
            onChange={(e) => {
              !!e
                ? setFilters({ ...filters, groupId: e })
                : setFilters({ ...filters, groupId: null });
              !!e && getFilteredExamsList(e);
              !e && setFilters({ ...filters, showTable: false });
              !e && setSelectedMoreExam(null);
            }}>
            {groupsList &&
              groupsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      {examsList && examsList.length > 0
        ? filters.showTable && (
            <Table
              style={{ marginTop: 50 }}
              columns={columns}
              dataSource={examsList}
              rowKey={'studentId'}
              bordered
            />
          )
        : filters.showTable && (
            <Empty style={{ marginTop: 50 }} description="По выбранному экзамену еще нету данных" />
          )}

      {selectedMoreExam && (
        <Table
          title={() => `${selectedMoreExam[0].exam.name}`}
          style={{ marginTop: 50, width: '100%' }}
          columns={columns2}
          dataSource={selectedMoreExam}
          bordered
          rowKey="id"
          scroll={{ x: '15px' }}
        />
      )}
    </React.Fragment>
  );
}

export default DirectorReport;
